import React from 'react';

import FilesTableTagsManager from './FilesTableTagsManager';
import InboxDocumentTagsManager from './InboxDocumentTagsManager';
import LibraryTagsManager from './LibraryTagsManager';
import { TagType } from './types';

interface TagsManagerProps {
  // For files table
  rowId?: string;
  isFilesTable?: boolean;
  fileId?: string | number;
  projectId?: string | number;
  // For file entry viewer
  inboxDocumentId?: string | number;
  assignedTags?: TagType[];
  setAssignedTags?: (tags: TagType[]) => void;
  // For library
  isLibrary?: boolean;
  folderId?: string;
  refetchFiles?: () => void;
  style?: React.CSSProperties;
  openTagModal?: { rowId: string | null; tagIndex: number | null };
  setOpenTagModal?: (modal: { rowId: string | null; tagIndex: number | null }) => void;
}

const TagsManager: React.FC<TagsManagerProps> = ({
  folderId,
  projectId,
  refetchFiles,
  isLibrary,
  isFilesTable,
  inboxDocumentId,
  assignedTags,
  setAssignedTags,
  rowId,
  style,
  openTagModal,
  setOpenTagModal,
  ...args
}) => {
  if (isLibrary) {
    return (
      <LibraryTagsManager
        inboxDocumentId={inboxDocumentId}
        folderId={folderId}
        projectId={projectId}
        refetchFiles={refetchFiles}
        assignedTags={assignedTags}
        setAssignedTags={setAssignedTags}
        style={style}
        {...args}
      />
    );
  }
  if (isFilesTable) {
    return (
      <FilesTableTagsManager
        projectId={projectId}
        assignedTags={assignedTags}
        setAssignedTags={setAssignedTags}
        rowId={rowId}
        inboxDocumentId={inboxDocumentId}
        openTagModal={openTagModal}
        setOpenTagModal={setOpenTagModal}
        {...args}
      />
    );
  }
  return (
    <InboxDocumentTagsManager
      inboxDocumentId={inboxDocumentId}
      projectId={projectId}
      refetchFiles={refetchFiles}
      assignedTags={assignedTags}
      setAssignedTags={setAssignedTags}
      style={style}
      {...args}
    />
  );
};

export default TagsManager;
